import {
  IMyNewExam,
  INewPublicExam,
  INewExamDetail,
  INewExamPaper,
  INewHighestScore,
  ISubmitNewExamPaper,
  IQuestionAnswer,
  IPersonDetail,
  IFaceRecognition,
  IExamTime,
  IExamBreakInfo,
  IScreenShotInfoParams,
  IErrorQuestion
} from './Interface'
import axios from '../../axios'

import apiService from '../../apiService'
import { generalApiPrefix } from '@const'
import UserStore from '@stores/UserStore'
import { apiConstants } from '@const/apiConstants'

export const URL = {
  // 正式考试列表
  realExamList: '/learn/app/clientapi/exam/realExamList.do',

  // 模拟考试列表
  simulationExamList: '/learn/app/clientapi/exam/simulationExamList.do',

  // 获取考试题目
  getExamQuestions: 'learn/app/clientapi/exam/getExamPaper.do',

  // 提交考试结果
  submitExamDetails: 'learn/app/clientapi/exam/submitExamPaper.do',

  // 获取考试结果
  getExamResult: 'learn/app/clientapi/exam/queryExamScoreByPaperNo.do',

  // 获取考试最高分
  getExamTopResult: 'learn/app/clientapi/exam/queryHighestScore.do',

  // 获取成绩列表
  getExamStory: 'learn/app/clientapi/exam/queryHistoryExam.do',

  // 获取试卷错题
  getErrorQuestion: 'learn/app/clientapi/exam/queryErrorListByPaperNo.do',

  // 获取考试错题
  getErrorList: 'learn/app/clientapi/exam/queryErrorListByExamId.do',

  // 获取考试时间
  getTime: 'learn/app/clientapi/exam/queryExamRemainTime.do',

  // 获取历史考试成绩
  getNewHistoryScore: 'learn/app/clientapi/exam/new/queryNewHistoryScore.do',
}

export default {
  getRealExamList: async (curPage: number, fromPage = 'my') => {
    const { body, code, message }: any = await axios.post(URL.realExamList, {
      curPage,
      numPerPage: 30,
      fromPage,
    })
    if (+code !== 0) {
      console.log(message)
      return {}
    }
    return body
  },

  getSimulationExamList: async (curPage: number, fromPage = 'my') => {
    const { body, code, message }: any = await axios.post(
      URL.simulationExamList,
      {
        curPage,
        numPerPage: 30,
        fromPage,
      }
    )
    if (+code !== 0) {
      console.log(message)
      return {}
    }
    return body
  },

  getMyNewExamList: (
    testType: string,
    pageNo: number
  ): Promise<ISuccessModel<IPageModel<IMyNewExam>>> =>
    apiService.get(`${generalApiPrefix}/exam/new/getMyNewExamList.do`, {
      testType,
      pageNo,
      pageSize: 30,
    }),

  getPublicNewExamList: (
    testType: string,
    pageNo: number
  ): Promise<ISuccessModel<IPageModel<INewPublicExam>>> =>
    apiService.get(`${generalApiPrefix}/exam/new/getPublicNewExamList.do`, {
      testType,
      pageNo,
      pageSize: 30,
    }),

  /** 获取断点续考信息 */
  getNewExamBreakInfo: (
    testId: string
  ): Promise<ISuccessModel<IExamBreakInfo>> =>
    apiService.get(`${generalApiPrefix}/exam/new/getNewExamBreakInfo.do`, {
      testId,
    }),

  getNewExamDetails: (testId: string): Promise<ISuccessModel<INewExamDetail>> =>
    apiService.get(`${generalApiPrefix}/exam/new/getNewExamDetails.do`, {
      testId,
    }),

  /* 判断当前用户的企业是否开启了人社增值服务 */
  getIsOpenHumanSocietyVas: () => {
    return axios.get(`${generalApiPrefix}/user/isOpenHumanSocietyVas.do`, {})
  },
  /* 挂靠在人社的考试资源再次调用接口获取是否可学 */
  selectResourceRule: (
    resourceId: string,
    resourceType: number,
    trainingItemId: string
  ): Promise<ISuccessModel<any>> =>
    apiService.get(
      `${generalApiPrefix}/trainingclass/training/item/selectResourceRule.do`,
      {
        resourceId,
        resourceType,
        trainingItemId,
      }
    ),

  getExamPaper: (examId: string): Promise<ISuccessModel<any>> =>
    apiService.get(`${generalApiPrefix}/exam/getExamPaper.do`, {
      examId,
    }),

  /** 提交答题记录 */
  submitExamPaper: (examId: string): Promise<ISuccessModel<any>> =>
    apiService.post(`${generalApiPrefix}/exam/submitExamPaper.do`),

  /** 获取考试成绩最高分 */
  queryNewHighestScore: (
    examId: string
  ): Promise<ISuccessModel<INewHighestScore>> =>
    apiService.get(`${generalApiPrefix}/exam/new/queryNewHighestScore.do`, {
      examId,
    }),

  /** 获取考试时间 */
  getExamTime: (
    examId: string,
    attemptId: string
  ): Promise<ISuccessModel<IExamTime>> =>
    apiService.get(`${generalApiPrefix}/exam/new/queryNewExamRemainTime.do`, {
      examId,
      attemptId,
    }),

  /** 获取考试题干id列表 */
  queryNewExamPaper: (examId: string): Promise<ISuccessModel<INewExamPaper>> =>
    apiService.post(`${generalApiPrefix}/exam/new/queryNewExamPaper.do`, {
      examId,
    }),

  /** 获取题干及选项信息 */
  queryQuestionDetail: (
    examId: string,
    questionIds: string[],
    questionNodeIds?: string[]
  ): Promise<ISuccessModel<any>> =>
    apiService
      .post(`${generalApiPrefix}/exam/new/queryQuestionDetail.do`, {
        examId,
        questionIds,
        questionNodeIds
      })
      .then((res: any) => {
        if (+res.code === 0) {
          return {
            ...res,
            body: JSON.parse(res.body),
          }
        }
        return res
      }),

  /** 考试报名 */
  submitExamEnroll: (examId: string): Promise<ISuccessModel<any>> =>
    apiService.get(`${generalApiPrefix}/exam/new/submitExamEnroll.do`, {
      examId,
    }),

  /** 提交考试答题记录--交卷的时候调用 */
  submitNewExamPaper: (
    examInfo: any
  ): Promise<ISuccessModel<ISubmitNewExamPaper>> =>
    apiService.post(`${generalApiPrefix}/exam/new/submitNewExamPaper.do`, {
      ...examInfo,
      os: apiConstants.STR_OS,
      terminalChannel: apiConstants.TERMINAL_CHANNEL,
    }),

  /** 提交用户答案 */
  submitQuestionAnswer: (
    answers: IQuestionAnswer[]
  ): Promise<ISuccessModel<any>> =>
    apiService.post(
      `${generalApiPrefix}/exam/new/submitQuestionAnswer.do`,
      answers
    ),

  /** 提交用户答案 不显示报错弹窗 */
  submitQuestionAnswerNext: (
    answers: IQuestionAnswer[]
  ): Promise<ISuccessModel<any>> =>
    apiService.post(
      `${generalApiPrefix}/exam/new/submitQuestionAnswer.do`,
      answers,
      {
        notShowErr: true,
      }
    ),

  /** 考试结果页获取考试错题 */
  queryErrorQuestionListByAttemptId: (
    examId: string,
    attemptId: string
  ): Promise<ISuccessModel<IQuestionAnswer[]>> =>
    apiService.get(
      `${generalApiPrefix}/exam/new/queryErrorQuestionListByAttemptId.do`,
      {
        examId,
        attemptId,
      }
    ),

  /** 详情页获取错题  questionIds[] */
  queryErrorQuestionListByExamId: (
    examId: string
  ): Promise<ISuccessModel<IErrorQuestion[]>> =>
    apiService.get(
      `${generalApiPrefix}/exam/new/queryAllErrorIdListByExamId.do`,
      {
        examId,
      }
    ),

  /** 人脸注册 */
  uploadFaceImg: (
    userType: string,
    password: string,
    faceImgBase64: string
  ): Promise<any> =>
    apiService.post(`${generalApiPrefix}/user/uploadFaceImg.do`, {
      userType,
      password,
      faceImgBase64,
      v: '2',
    }),

  /** 考试人脸采集备份 */
  faceCollectBackUp: (
    attemptId: string,
    examId: string,
    faceImage: string,
    sort: number
  ): Promise<ISuccessModel<any>> =>
    apiService.post(`${generalApiPrefix}/exam/faceCollectBackUp.do`, {
      attemptId,
      examId,
      faceImage,
      sort,
    }),

  /** 查询用户是否有上传头像认证 */
  personDetail: (
    searchedUserId: string
  ): Promise<ISuccessModel<IPersonDetail>> =>
    apiService.get(`${generalApiPrefix}/user/personDetail.do`, {
      searchedUserId,
    }),

  /** 考试监考头像认证 */
  faceRecognition: (
    attemptId: string,
    examId: string,
    faceImage: string
  ): Promise<ISuccessModel<IFaceRecognition>> =>
    apiService.post(
      `${generalApiPrefix}/exam/faceRecognition.do`,
      {
        attemptId,
        examId,
        faceImage,
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
      }
    ),

  /** 校验密码 */
  validatePassword: (password: string): Promise<any> =>
    apiService.get(`${generalApiPrefix}/user/validatePassword.do`, {
      password,
      v: '2',
    }),

  /** 获取历史成绩 */
  queryNewHistoryScore: (examId: string): Promise<ISuccessModel<any>> =>
    apiService.get(`${generalApiPrefix}/exam/new/queryNewHistoryScore.do`, {
      examId,
    }),

  /** 获取用户答题记录 */
  queryQuestionAnswer: (
    examId: string,
    attemptId: string
  ): Promise<ISuccessModel<IQuestionAnswer[]>> =>
    apiService.get(`${generalApiPrefix}/exam/new/queryQuestionAnswer.do`, {
      examId,
      attemptId,
    }),

  /** 获取证书 */
  queryExamCertificate: (examId: string): Promise<ISuccessModel<any>> =>
    apiService.get(`${generalApiPrefix}/exam/new/queryExamCertificate.do`, {
      examId,
    }),

  /** 考试时长上报 */
  examReport: (examId: string): Promise<ISuccessModel<any>> =>
    apiService.post(
      `/learn/app/clientapi/exam/new/reportExaminationDuration.do`,
      {
        examId,
        upTime: new Date().getTime(),
        userId: UserStore.userId,
        enterpriseId: UserStore.enterpriseId,
        terminalChannel: apiConstants.TERMINAL_CHANNEL,
      }
    ),

  /** 获取上传大小限制 */
  getMaxUploadSize: (): Promise<any> =>
    apiService.post(`/learn/app/clientapi/exam/new/getMaxUploadSize.do`),

  /** 查看截屏状态信息 */
  getScreenShotInfo: (params: IScreenShotInfoParams) =>
    apiService.post('/learn/app/clientapi/screenShot/queryScreenShotInfo.do', {
      userId: UserStore.userId,
      ...params,
    }),

  /** 切屏上报 */
  reportOnScreen: (params: any): Promise<ISuccessModel<any>> =>
    apiService.post(
      `${generalApiPrefix}/cutScreen/submitCutScreenRecord.do`,
      {
        ...params
      }
    ),

  /** 查看切屏状态信息 */
  queryCutScreenInfo: (params: any): Promise<ISuccessModel<any>> =>
    apiService.post(
      `${generalApiPrefix}/cutScreen/queryCutScreenInfo.do`,
      {
        ...params
      }
    ),

  /** 查询增值服务是否开启 */
  queryVasOperation2NativeList: (params: any): Promise<ISuccessModel<any>> =>
    apiService.get(
      `${generalApiPrefix}/misc/queryVasOperation2NativeList.do`,
      {
        ...params
      }
    ),

  getRank: (params: any): Promise<ISuccessModel<any>> =>
    apiService.get(
      `${generalApiPrefix}/exam/new/newExamRank.do`,
      {
        ...params
      }
    ),

    isHasAttempt: (params: any): Promise<ISuccessModel<any>> =>
    apiService.get(
      `${generalApiPrefix}/exam/new/isHasAttempt.do`,
      {
        ...params
      }
    ),
}
